import { type IntlShape } from 'react-intl-next';

import { messages } from './messages';

const labelText = (intlApi: IntlShape) => ({
	previousOnCall: intlApi.formatMessage(messages.previousOnCall),
	shiftParticipant: intlApi.formatMessage(messages.shiftParticipant),
});

export { labelText };
